(ns frontend.view.nev.kyc.process-status-views.prefilled-status
  (:require [basic-components.field-editor :as field-editor]
            [common.email :as email]
            [common.localization :as loc]
            [common.util :as cu]
            [frontend.actions.kyc-process :as kyc-process-actions]
            [frontend.logging :as logging]
            [frontend.utils :as fu]
            [frontend.view.nev.kyc.process-status-views.view-utils :as kvu]
            [ui.components.button.view :as button]))

(defn view [_state-atom local-atom process-entity]
  [:div.d-flex.flex-column.flex-1-hidden
   [:div.d-flex.flex-column.flex-1-hidden.scroll-y
    [:div.container.pt-4
     [:div.card--kyc.card--kyc--min-height
      [:div.card-body
       [field-editor/view
        {:editor/type :editor.type/email
         :class-name  (fu/cs "")
         :value       (:email @local-atom)
         :draggable?  false
         :state-atom  local-atom
         :attribute   :email
         :label       (loc/tr :email)
         :on-save!    (fn [attribute new-value]
                        (if (empty? (cu/str-trim new-value))
                          (swap! local-atom dissoc attribute)
                          (swap! local-atom assoc attribute new-value)))
         :on-change   (fn [attribute new-value]
                        (if (empty? (cu/str-trim new-value))
                          (swap! local-atom dissoc attribute)
                          (swap! local-atom assoc attribute new-value)))
         :mandatory?  true
         :tools       [:tool-item/clear :tool-item/cancel]}]
       #_[field-editor/view
          {:editor/type :editor.type/text-simple
           :draggable?  false
           :class-name  (fu/cs "mt-3")
           :value       (:phone @local-atom)
           :state-atom  local-atom
           :attribute   :phone
           :label       (loc/tr :mobile-number-for-sms-validation)
           :on-save!    (fn [attribute new-value]
                          (if (empty? (cu/str-trim new-value))
                            (swap! local-atom dissoc attribute)
                            (swap! local-atom assoc attribute new-value)))
           :on-change   (fn [attribute new-value]
                          (if (empty? (cu/str-trim new-value))
                            (swap! local-atom dissoc attribute)
                            (swap! local-atom assoc attribute new-value)))
           :mandatory?  false
           :tools       [:tool-item/clear :tool-item/cancel]}]
       [:p.mt-3.mb-4.text-xs.px-3
        (loc/tr :confirm-kyc-recipient-contact-email)]]]]]

   [:div.d-flex.flex-static.kyc-submit-footer
    [:div.container
     [:div.d-flex.justify-content-between
      [kvu/exit-button process-entity :en]
      [button/primary-solid
       {:disabled? (or (:processing? @local-atom)
                       (not (email/valid-email? (:email @local-atom))))
        :on-click  (fn [_]
                     (swap! local-atom assoc :processing? true)
                     (kyc-process-actions/*->invite! {:email          (:email @local-atom)
                                                      :phone          (:phone @local-atom)
                                                      :kyc-process-id (:db/id process-entity)}
                                                     (fn [_resp]
                                                       (swap! local-atom dissoc :processing?))
                                                     (fn [err]
                                                       (swap! local-atom dissoc :processing?)
                                                       (logging/error "Failed to send KYC invitation " err))))}
       (loc/tr :send)]]]]])

